/**
 * Delegaciones Freematica (código → nombre legible). El código coincide con
 * la provincia y es estable entre empresas (verificado contra las tiendas
 * activas). Si aparece una delegación sin mapear se muestra el código.
 */
export const DELEGACIONES = {
  '01': 'Álava',
  '06': 'Badajoz',
  '08': 'Barcelona',
  '10': 'Cáceres',
  '12': 'Castellón',
  '21': 'Sevilla',
  '26': 'La Rioja',
  '28': 'Madrid',
  '29': 'Málaga',
  '45': 'Toledo',
  '46': 'Valencia',
  '51': 'Ceuta',
  '52': 'Melilla',
};

export const nombreDelegacion = (cod) =>
  DELEGACIONES[String(cod)] || `Delegación ${cod}`;
